<script lang="ts">
  import EmojiReaction from "./EmojiReaction.svelte";
  import AddEmojiReactionButton from "./AddEmojiReactionButton.svelte";
  import type { Reaction } from "app/models/forums";

  export let reactions: Reaction[];
  export let enabled: boolean = false;
</script>

{#if enabled || reactions.length > 0}
  <div class="flex flex-wrap gap-2">
    {#if enabled}
      <AddEmojiReactionButton on:addReaction />
    {/if}
    {#each reactions
      .filter((reaction) => reaction.count > 0)
      .sort((a, b) => Number(new Date(a.created)) - Number(new Date(b.created))) as reaction (reaction.emoji)}
      <EmojiReaction {reaction} on:reaction {enabled} />
    {/each}
  </div>
{/if}
